(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('tilesEditableItem', tilesEditableItem);

    function tilesEditableItem() {
        return {
            restrict: 'E',
            controller: tilesEditableItemCtrl,
            scope: {
                options: '=',
                item: '=',
                onEdit: '&',
                mode: '='
            },
            template: '',
        };
    }

    function tilesEditableItemCtrl($scope, $compile, $element, lodash, $templateCache) {
        this.$onInit = function() {
            initTemplate();

            $scope.getEnumLabel = getEnumLabel;
        }

        function initTemplate() {
            var template = '';

            if (lodash.has($scope, 'options.template')) {
                template = $scope.options.template;
            } else {
                if (lodash.has($scope, 'options.templateUrl')) {
                    template = $templateCache.get($scope.options.templateUrl);
                }
            }
            $element.html(template);
            $compile($element.contents())($scope);
        }

        function getEnumLabel(type, value) {
            return lodash.get($scope.options, 'enums.' + type + '[' + value + ']', '');
        }
    }
})();